import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Button, { ButtonTheme } from 'builder/components/Button'
import { Icon20 } from 'builder/components/Icon'
import { FontWeights, Typography } from 'builder/styles/typography'

import { WidgetImage } from '../../widget.styles'

export const Image = styled(WidgetImage)``

export const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
  z-index: 1;
`

export const InitialActionButtonsContainer = styled.div`
  display: flex;
  gap: 12px;

  ${Media.Phone`
    justify-content: center;
    flex-direction: row-reverse;
    gap: 8px;
  `}
`

export const InitialContinueButton = styled(Button)`
  color: ${Colors.White};
  background-color: ${Colors.Green50};

  ${Media.Phone`
    width: 100%;
  `}

  &:hover,
  &:focus-visible {
    background-color: ${Colors.Green60};
  }
`

export const InitialCloseButton = styled(Button).attrs({
  theme: ButtonTheme.ghost,
})`
  ${Media.Phone`
    width: 100%;
  `}
`

export const ProgressActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  ${Media.Phone`
    gap: 8px;
    flex-direction: row;
    justify-content: center;
  `}
`

export const ButtonContainer = styled.button`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 11px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};

  ${Media.Phone`
    width: 100%;
    justify-content: center;
  `}
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const ScoreText = styled.p`
  ${Typography.Body}
  ${FontWeights.DemiBold}

  color: ${Colors.Green50};
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`

export const AnimationVideoContainer = styled.div`
  overflow: hidden;
  width: fit-content;
  height: 100%;

  ${Media.Phone`
    height: 160px;
    margin: 0 auto;
  `}
`

export const AnimationVideo = styled.video`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  transform: scale(1.01);
  transform-origin: center;
`
